// What the removal box may say about ONE document on an expense, read from the
// server's own answers. The screen never works these out for itself.

/** The three facts for the document that was clicked, or null if it is not there. */
export function removalFacts(attachments, docId) {
  const list = attachments || [];
  const doc = list.find((a) => a.id === docId);
  if (!doc) return null;
  return {
    deletesTheFile: !!doc.deletes_the_file,
    shared: !!doc.shared,
    isTheLastOne: list.length === 1,
  };
}

/** Are these the same three answers? Two missing answers are not "the same". */
export function sameFacts(a, b) {
  return !!a && !!b
    && a.deletesTheFile === b.deletesTheFile
    && a.shared === b.shared
    && a.isTheLastOne === b.isTheLastOne;
}

/**
 * The expense as it is NOW, and the facts for one of its documents. The answers
 * go stale while a form is open (the document's other use can be removed
 * elsewhere), so the box is drawn from this and not from what the form loaded.
 * A failed read throws: no box is drawn from old facts.
 */
export async function freshRemovalFacts(api, expenseId, docId) {
  const { data } = await api.get(`/expenses/${expenseId}`);
  return { expense: data, facts: removalFacts(data?.attachments, docId) };
}

/**
 * Only the newest request counts. Each request takes a ticket; an answer is
 * acted on only while its ticket is still the newest. `cancel` retires every
 * ticket handed out so far (the box was closed, the form moved on).
 */
export function latestOnly() {
  let newest = 0;
  return {
    next: () => { newest += 1; return newest; },
    isCurrent: (ticket) => ticket === newest,
    cancel: () => { newest += 1; },
  };
}
